import { PeriscopeProfile } from '.';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';
export const PeriscopeProfileList = ({ items, parentIndex, sonarObjectType }) => {
    const { openPeriscope } = usePeriscopeActions();
    const handleClick = useCallback((item) => {
        const { displayName, sonarObjectId } = item;
        openPeriscope({
            id: sonarObjectId,
            name: displayName,
            openedFromIndex: parentIndex,
            type: sonarObjectType
        });
    }, [openPeriscope, parentIndex, sonarObjectType]);
    return (React.createElement(React.Fragment, null, items.map((item) => React.createElement(PeriscopeProfile, { item: item, key: item.sonarObjectId, onClick: handleClick }))));
};
